import { Bound } from "lib/@components/binding/Bound"
import { getBasePlanId } from "routes/plan/controller/use-plan"
import { getPublishedPlan } from "routes/plan/controller/publish-plan"
import { FilterRegisterHeaders } from "../assets/register-table-headers"
import { removeRegisterHeaders } from "./remove-register-headers"
import { AuditTitle } from "slot-definitions"
import { VersionLockedLabel } from "./version-locked-label"

export function RegimeDraftLockChecker({ regime, children }) {
    const id = getBasePlanId(regime)

    const result = getPublishedPlan.useResults(id, "publish")
    const publishedDate = result?.plan?._modified
    const isRegimeDraftLocked = !!result?.tree
    const regimeDraftVersion = result?.tree?.version + 2

    FilterRegisterHeaders.useEvent((props) => removeRegisterHeaders(props, isRegimeDraftLocked), [isRegimeDraftLocked])

    AuditTitle("maintenanceRegime").usePlug(
        <VersionLockedLabel regimeDraftVersion={regimeDraftVersion} isRegimeDraftLocked={isRegimeDraftLocked} />,
        [isRegimeDraftLocked, regimeDraftVersion]
    )

    return (
        <Bound isRegimeDraftLocked={isRegimeDraftLocked} regimeDraftPublishedDate={publishedDate}>
            {children}
        </Bound>
    )
}
